
<script setup>
    import { ref, onMounted, computed } from 'vue'

    const props = defineProps({
        formData: Object,
        mode: {
            type: String,
            default: 'create'
        }
    })
    const emit = defineEmits(['back', 'complete', 'close'])
    // 顔画像ファイル情報一覧(選択済みの画像のみ)
    const fileInfos = ref([])
    

    // ユーザー登録画面に戻る
    const backRegist = () => {
        if (props.mode === 'edit') {
            emit('back', 'edit')
        } else {
            emit('back', 'create')
        }
    }
    // ユーザー登録画面クローズ
    const closeRegist = () => {
        emit('close')
    }
    // ユーザー登録処理へ
    const registUser = () => {
    emit('complete', props.formData)
    }

    const showImageSection = computed(() => {
        return fileInfos.value.length > 0
    })
    const breadcrumbTitle = computed(() => {
        return props.mode === 'edit' ? '利用者情報更新' : '利用者新規登録'
    })
    const headerTitle = computed(() => {
        return props.mode === 'edit' ? '利用者情報更新 確認' : '利用者新規登録 確認'
    })
    const descriptionText = computed(() => {
        return props.mode === 'edit'
            ? '以下の内容で利用者情報を更新します。内容をご確認のうえ、更新を実行してください。'
            : '以下の内容で利用者を登録します。内容をご確認のうえ、登録を実行してください。'
    })
    const buttonText = computed(() => {
        return props.mode === 'edit' ? '更新する' : '登録する'
    })

    onMounted(() => {
        const images = props.formData?.images || []
        fileInfos.value = images
            .map((image, index) => ({ ...image, index }))
            .filter(image => image.file)
            .map(image => ({
                index: image.index, // 画像番号(0始まり)
                previewImg: image.previewImg,
                fileName: image.file.name,
                fileType: image.file.type ? image.file.type.split('/')[1].toUpperCase() : '',
                fileSize: Math.round(image.file.size / 1024) + ' KB',
                imageSize: ''
            }))

        // 画像サイズはプレビュー画像の読み込み後に設定
        fileInfos.value.forEach(info => {
            const img = new Image();
            img.onload = () => {
                info.imageSize = `${img.width} × ${img.height} px`
            }
            img.src = info.previewImg
        })
    })
</script>


<template>
  <div class="mainView">
    <nav class="breadcrumb">
      <span class="breadcrumb-sub" @click="closeRegist">利用者管理 </span>
        <span> &gt; </span>
        <span class="breadcrumb-main"> {{ breadcrumbTitle }}</span>
    </nav>
    <div class="titleArea">
        <p class="title">{{ headerTitle }}</p>
        <div class="titleTextArea">
            <p class="titleText">{{ descriptionText }}</p>
        </div>
    </div>
    <div class="confirmArea">
        <div class="confirmUserInfoArea">
            <p class="confirmUserTitle" ><span class="fontColorPk">① </span>基本情報</p>
            <table class="confirmTable">
                <tbody>
                    <tr>
                        <th>ユーザーID</th>
                        <td>{{ formData.userId }}</td>
                    </tr>
                    <tr>
                        <th>ユーザー名</th>
                        <td>{{ formData.userName }}</td>
                    </tr>
                    <template v-for="(info, index) in formData.userInfos" :key="index">
                        <tr v-if="info.name?.trim() || info.content?.trim()">
                            <th>{{ info.name }}</th>
                            <td>{{ info.content }}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div v-if="showImageSection" class="confirmUserImgArea">
            <p class="confirmUserTitle" ><span class="fontColorPk">② </span>顔画像（最大3枚）</p>
            <div v-for="info in fileInfos" :key="info.index" class="imgConfirmArea">
                <div class="imgConfirmHeader">
                    <span class="imgConfirmTitle">画像 {{ info.index + 1 }}</span>
                    <span v-if="info.index === 0" class="requireView confirmRequireView">必須</span>
                    <span v-else class="optionalView">任意</span>
                </div>
                <div class="imgBox">
                    <img :src="info.previewImg">
                </div>
                <table class="confirmTable">
                    <tbody>
                        <tr>
                            <th>ファイル名</th>
                            <td>{{ info.fileName }}</td>
                        </tr>
                        <tr>
                            <th>ファイル形式</th>
                            <td>{{ info.fileType }}</td>
                        </tr>
                        <tr>
                            <th>ファイルサイズ</th>
                            <td>{{ info.fileSize }}</td>
                        </tr>
                        <tr>
                            <th>画像サイズ</th>
                            <td>{{ info.imageSize }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="exeRegisttButtonArea">
      <button type="button" class="clearButton" @click="backRegist">戻る</button>
      <button class="clearButton" @click="closeRegist">キャンセル</button>
      <button class="nextButton" @click="registUser">{{ buttonText }}</button>
    </div>
  </div>
</template>


<style scoped>
    .breadcrumb{
        align-items: left;
        text-align: left;
        padding-top:15px;
        padding-left:20px;
    }
    .breadcrumb-sub{
        font-size: 18px;
        margin: 0 10px;
        cursor:pointer;
    }
    .breadcrumb-main{
        font-size: 18px;
        margin: 0 10px;
        font-weight: bold;
    }
    .confirmArea {
        width:95%;
        margin: 30px;
        border-radius: 10px;
        border: 1px solid #e0e0e0;
        padding:20px;
    }
    .confirmUserInfoArea{
        width:100%;
        border-bottom: 1px solid #cecbcb;
        padding:15px;
    }
    .confirmUserTitle {
        font-size: 18px;
        font-weight: bold;
        text-align: left;
    }
    .confirmTable{
        width: 90%;
        margin: 0 0 0 0;
    }
    .confirmTable th {
        white-space: nowrap;
        height: 75px;
        background-color:#e7e5e5;
        text-align: left;
        padding: 0 20px;
    }
    .confirmTable td {
        background-color: white;
        text-align: left;
        padding-left: 20px;
        width: 70%;
    }
    
    .confirmTable tr:first-child th:first-child {
        border-top-left-radius: 8px;
    }

    .confirmTable tr:first-child td:last-child {
        border-top-right-radius: 8px;
    }

    .confirmTable tr:last-child th:first-child {
        border-bottom-left-radius: 8px;
    }   

    .confirmTable tr:last-child td:last-child {
        border-bottom-right-radius: 8px;
    }

    .confirmUserImgArea {
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-top: 20px;
        padding: 0 15px;
    }
    .exeRegisttButtonArea {
        display: flex;
        justify-content: center;
        margin:20px;
        gap:40px;
    }
    .imgConfirmArea{
        display: flex;
        align-items: flex-start;
        gap: 30px;
        background: white;
        border: 1px solid #e0e0e0;
        border-radius: 10px;
        padding: 16px;
    }
    .imgConfirmHeader{
        display: flex;
        align-items: center;
        gap: 8px;
        width: 140px;
        flex-shrink: 0;
    }
    /* 確認画面の画像1「必須」は背景色と文字色を反転 */
    .confirmRequireView{
        color: white;
        background-color: #ff1493;
    }
    .imgConfirmTitle{
        font-weight: bold;
        white-space: nowrap;
    }
    .imgConfirmArea .confirmTable{
        flex: 1;
    }
    .imgInfo {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
    }
    .imgBox {
        width: 200px;
        height: 200px;
        border-radius: 10px;
        overflow: hidden; 
        display: flex;        
        align-items: center;
        justify-content: center;
        background: #f5f5f5;
    }
    .imgBox img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .clearButton, .nextButton{
        width: 200px;
    }
    @media (max-width: 1024px) {
        .confirmArea {
            width: 100%;
            margin: 20px auto;
            padding: 16px;
        }
        .confirmUserImgArea {
            flex-wrap: wrap;
        }
        .imgConfirmArea {
            flex-direction: column;
            gap: 20px;
        }
        .imgBox {
            width: 100%;
        }
        .confirmTable {
            width: 100%;
        }
        .exeRegisttButtonArea {
            flex-direction: column;
            gap: 12px;
        }

    }

    @media (max-width: 540px) {
        *, *::before, *::after {
            box-sizing: border-box;
        }
        .breadcrumb{
            margin-top: 15px;
            padding:10px;
            font-size:14px;
        }
        .breadcrumb-sub, .breadcrumb-main{
            font-size:16px;
            margin:0 3px;
        }
        .confirmArea {
            width:100%;
            max-width:100%;
            margin:15px 0;
            padding:15px;
        }
        .confirmTable, .confirmTable tbody,.confirmTable tr, 
        .confirmTable th, .confirmTable td{
            display:block;
            width:100%;
        }
        .confirmTable th{
            height:auto;
            padding:12px;
            border-radius:0;
        }
        .confirmTable td{
            padding:12px;
        }
        .confirmTable tr{
            margin-bottom:15px;
            border-radius:8px;
            overflow:hidden;
            border:1px solid #eee;
        }
        .confirmUserTitle {
            font-size: 16px;
        }
        .confirmUserImgArea{
            display:block;
        }
        .imgConfirmArea{
            display:flex;
            flex-direction:column;
            gap:15px;
            align-items:center;
        }
        .imgBox{
            width:100%;
            max-width:260px;
            height:260px;
            margin:auto;
        }
        .exeRegisttButtonArea{
            flex-direction:column;
            gap:10px;
        }
        .clearButton, .nextButton{
            width:100%;
            max-width:none;
        }

    }
</style>
